import { getAmplitudeInstance } from '../amplitudeHelpers';

type logTrailDetailsReviewsPhotoEndReachedParams = {
  num_photos: number;
  review_id: number;
  trail_id: number;
};

/**
 * Triggered when a user reaches the end of the photos by scrolling all the way through available photos in a given review
 * @param params - Attributes to log with the amplitude event
 * @param params.num_photos - Total number of photos displayed in the carousel.
 * @param params.review_id - The review id of the review.
 * @param params.trail_id - The trail id of the associated trail details page.
 */
const logTrailDetailsReviewsPhotoEndReached = (
  { num_photos, review_id, trail_id }: logTrailDetailsReviewsPhotoEndReachedParams,
  callback?: () => void
) => {
  getAmplitudeInstance().logEvent(
    'trail details reviews photo end reached',
    { 'num photos': num_photos, 'review id': review_id, 'trail id': trail_id },
    callback
  );
};

export default logTrailDetailsReviewsPhotoEndReached;
